module.exports = __webpack_public_path__ + "img/VP-ECONew_Overview-ECsmall_1.264848a6.jpg";